module.exports = __webpack_public_path__ + "img/crea-tu-perfil-en-Relink-md.c6e628f.webp";